import angular from 'angular';
import 'angular-toastr';
import moment from 'moment';
import Rx from 'rx';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import {normalizeTimeframe} from '../../common/datetime/date-ranges';
import template from './analyticsIndex.jade';

export class AnalyticsIndexController {
  /* @ngInject */
  constructor($scope, $stateParams, $filter, Resource, GamesResource, currentGame, GameAnalyticsResource, $state, toastr, $localStorage) {
    this.$stateParams = $stateParams;
    this.apiDate = $filter('apiDate');
    this.translate = $filter('translate');
    this.GamesResource = GamesResource;
    this.currentGame = currentGame;
    this.GameAnalyticsResource = GameAnalyticsResource;
    this.Resource = Resource;
    this.GameAnalyticsCohortResource = this.Resource('game-analytics/cohort');
    this.query = new Rx.Subject();
    this.$state = $state;
    this.$localStorage = $localStorage;
    this.refresherCount = 0;

    this.availableSearchParams = [
      {key: "countryCode", name: "Country", placeholder: "Country..."},
      {key: "platform", name: "Platform", placeholder: "Platform..."},
      {key: "acquisitionSource", name: "Acquisition Source", placeholder: "Acquisition Source..."},
      {key: "paying", name: "Paying", placeholder: "Paying..."},
      {key: "deviceId", label: "Device ID", placeholder: "Device ID..."}
    ];

    this.filterFieldConfigs = {
      countryCode:{},
      platform:{},
      paying:{},
      acquisitionSource:{},
      deviceId: {field_label: "Player - Device ID", possible_values: [{ valueToShow: this.translate('deviceIdKnown'), value: this.translate('deviceIdKnown') }, { valueToShow: this.translate('deviceIdUnknown'), value: this.translate('deviceIdUnknown') }], labelToValue: {[this.translate('deviceIdKnown')]: true, [this.translate('deviceIdUnknown')]: false}},
    };

    this.installsConversionEventsKeysValues = {
      ALL: '30 days trend – Installs-to-Events - App',
      WITHOUT_REAPPI: 'Without ReAppi',
      REAPPI_ONLY: 'ReAppi Only'
    };

    this.installsConversionEventsUpliftKeysValues = {
      CONTROL: '30 days trend – Installs-to-Events - Control group',
      TREATMENT: '30 days trend – Installs-to-Events - Treatment group'
    };

    this.timeframe = normalizeTimeframe(this.$localStorage.timeframe);
    this.searchParams = {};

    this.series = {
      installsConversionEvents: [{
        label: this.translate('installsConversionEvents'),
        metric: 'daily_app_conversion',
        format: 'percentage',
        type: 'spline',
        noDateInTooltip: true,
        getTooltip: ((data) => data.key),
        queryParams: {cohort_request_type: 'REGULAR', cohort_request_mode: 'NULL_SEGMENT'},
        transformResponse: ((res) => this.installsConversionEventsTransformResponse(res, this.installsConversionEventsKeysValues))
      }],
      new_players: [{
        metric: 'new_players',
        type: 'spline',
        bigLabel: 'sum',
        format: 'number'
      }],
      dau: [{
        metric: 'dau',
        type: 'spline',
        bigLabel: 'avg',
        format: 'number'
      }],
      arp_dau: [{
        metric: 'arp_dau',
        type: 'column',
        bigLabel: 'avg',
        format: (() => this.game.currency)
      }],
      arp_pu: [{
        metric: 'arp_pu',
        type: 'spline',
        bigLabel: 'avg',
        format: (() => this.game.currency)
      }],
      sessions_to_dau: [{
        metric: 'sessions_to_dau',
        type: 'area',
        bigLabel: 'avg'
      }],
      sessions: [{
        metric: 'sessions',
        type: 'area',
        bigLabel: 'sum',
        format: 'number'
      }],
      conversion_rate: [{
        metric: 'conversion_rate',
        type: 'area',
        bigLabel: 'avg',
        format: 'percentage'
      }],
      transactions: [{
        metric: 'transactions',
        type: 'spline',
        bigLabel: 'sum',
        format: 'number'
      }],
      revenue: [{
        metric: 'revenue',
        type: 'spline',
        bigLabel: 'sum',
        format: (() => this.game.currency)
      }],
      dpu: [{
        metric: 'dpu',
        type: 'spline',
        bigLabel: 'avg',
        format: 'number'
      }],
      conversions: [
        {
          label: 'Conversions',
          metric: 'conversions',
          type: 'column',
          format: 'number',
          bigLabel: 'avg',
        },
        {
          metric: 'share_trend',
          type: 'spline',
          format: 'percentage',
          bigLabel: 'avg',
        }
      ],
    };

    this.getGame($stateParams.gameId);

    //// TODO remove $watch after ng-change="vm.updateQuery()" is integrated into searchbox component
    let vm = this;
    $scope.$watch('vm.searchParams', function (newValue) {
      if (newValue) {
        vm.updateGameAnalyticsQuery();
      }
    }, true);
  }

  getAggregationType(metric) {
    switch(metric) {
      case 'daily_app_conversion':
      case 'ctr':
      case 'ecpc':
      case 'ecpa':
      case 'ecpm':
        return 'avg';
      default:
        return 'sum';
    }
  }

  sortBreakdownSeries(series) {
    let aggregationType = this.getAggregationType(_.get(series, '[0].query.metric'));
    return _.sortBy(series, (serie) => { return -serie.data.summary[aggregationType]; })
  }

  translateInstallsConversionEvents(data, conversionEventsKeysValues) {
    return ({
      key: conversionEventsKeysValues[data.key],
      rows: data.rows,
      summary: data.summary
    })
  }

  installsConversionEventsTransformResponse(series, conversionEventsKeysValues) {
    const transformed = _.map(series, (value) => ({data: this.translateInstallsConversionEvents(value.data, conversionEventsKeysValues), query: value.query}))
    return this.sortBreakdownSeries(transformed);
  }

  refreshData() {
    this.updateGameAnalyticsQuery(true);
  }

  getGame(id) {
    this.GamesResource.one(id).get()
      .then((res) => {
        this.game = res;
        this.game.getGameDeveloper()
          .then((gameDeveloper) => {
            this.game.currency = gameDeveloper.currency;
            this.currentGame.onNext(this.game);
            this.updateGameAnalyticsQuery();
          });
      })
  }

  updateGameAnalyticsQuery(doRefresh) {
    this.$localStorage.timeframe = this.timeframe;

    if (!this.game) {
      return;
    }

    let query = {
      game_id: this.game.id,
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate),
      countryCode: this.searchParams.countryCode,
      platform: this.searchParams.platform,
      acquisitionSource: this.searchParams.acquisitionSource,
      paying: this.searchParams.paying,
      deviceId: this.searchParams.deviceId ? this.filterFieldConfigs.deviceId.labelToValue[this.searchParams.deviceId] : null,
    };

    if (this.timeframe.comparisonStartDate && this.timeframe.comparisonEndDate) {
      query.comparison = {
        start_date: this.apiDate(this.timeframe.comparisonStartDate),
        end_date: this.apiDate(this.timeframe.comparisonEndDate)
      };
    }

    if(doRefresh) {
      query.refresherCount = ++this.refresherCount;
    }

    this.getGameAnalyticsOverview(query);

    this.query.onNext(query);
  }

  createSegment() {
    // TODO implement with segments create
    alert('go to segment create with: ' + JSON.stringify(this.searchParams));
  }

  getGameAnalyticsOverview(query) {
    this.GameAnalyticsResource.one('overview').get(query).then((res) => {
      this.gameAnalyticsOverview = res.data;
    });
  }

}

export function AnalyticsIndexComponent() {
  return {
    template,
    controller: AnalyticsIndexController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.analytics.index', [
  'toastr',
  ServicesModule.name,
  ResourcesModule.name
])
.directive('analyticsIndex', AnalyticsIndexComponent);



/** WEBPACK FOOTER **
 ** ./src/components/analytics/analyticsIndex.js
 **/